import { Flex, Text, tokens } from "shared/components/Spor";

export const InfoContent = () => (
  <Flex direction="column" gap={tokens.default.size.spacing[2]}>
    <Text variant="sm">
      Maksimalt transportbehov viser antall reisende for den valgte
      tidshorisonten. Data hentes hvert 15. minutt, og markørene i grafen
      oppdateres automatisk.
    </Text>
    <Text variant="sm">Markørene viser:</Text>

    <ul style={{ listStyleType: "circle" }}>
      <li>
        <b>Siste:</b> Nyeste datapunkt i forhold til nåværende tidspunkt.
      </li>
      <li>
        <b>Maks:</b> Tidspunktet med flest reisende samtidig, altså når
        transportbehovet er størst.
      </li>
      <li>
        <b>Ved hover:</b> Antall kjøretøy som er bekreftet av leverandørene.
      </li>
    </ul>
    <Text variant="sm" mt={tokens.default.size.spacing[2]}>
      Fargekodene i grafen forklares øverst i høyre hjørne.
    </Text>
  </Flex>
);
